<template>
  <button class="stack" :class="{ 'stack--empty': !count }" :title="title" :aria-label="title" @click="$emit('open')">
    <span class="stack__pile" aria-hidden="true">
      <span class="stack__card stack__card--3" />
      <span class="stack__card stack__card--2" />
      <span class="stack__card stack__card--1">{{ count }}</span>
    </span>
    <span class="stack__label">{{ label }}</span>
  </button>
</template>

<script>
// A pile of cards, drawn as a pile. Matt: "the My Deck button should look
// like a little deck. It doesn't need to say the words My Deck... let's put
// it on the bottom left corner, tucked in next to the card hand. Let's have
// the deck on the left, and we'll have a discard pile on the right, so we
// can see how many are in each spot."
export default {
  name: 'CardStack',
  props: {
    count: { type: Number, required: true },
    label: { type: String, required: true },
  },
  emits: ['open'],
  computed: {
    title() {
      return `${this.count} ${this.count === 1 ? 'card' : 'cards'} in the ${this.label}. Tap to look through your deck.`;
    },
  },
};
</script>
